import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import UserCampaignDraftsItem from "../user-campaigns-drafts-item/component"
import UserCampaignDraftsItemList from "../user-campaigns-drafts-item-list/component"
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {langRegister} from "../../services/langRegister";
import {demoRegister} from "../../services/demoRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import LanguageButton from "../language-button/component";
import UserCampaignsArchivedItem from "../user-campaigns-archived/component";
import {agentRegister} from "../../services/agentRegister";
import Moment from "react-moment";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class userCampaignsDrafts extends Component {

    constructor(props) {
        super(props);
        this.state = {
            campaigns: [],
            isLoading: true,
            search: "",
            per_page: 10,
            page: 0,
            isLoadingButton: false,
            show_loadmore: true,
            isLoadingUser: true,
            isLoadingFeed: true,
            show_list_switch: true,
            list_switch: false
        };
        this._setLoader = this._setLoader.bind(this);
        this._updateAmount = this._updateAmount.bind(this);
    };

    componentDidMount() {
        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/user/campaigns/drafts');
            ReactGA4.send({ hitType: "pageview", page: "/user/campaigns/drafts" });
        }
        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }
        this._updateUserData();
        this._updateFeedData();
        this._updateCampaigns();
    }

    _updateUserData() {
        let user = userRegister.get();
        if (user) {
            this.setState({user: user, user_email: user.email, reseller: user.reseller, inhouse: user.inhouse, isLoadingUser: false}, () => {
                this.setState({isLoadingFeed: false})
            });
        } else {
            this.setState({user: false, isLoadingUser: false}, () => {
                this.setState({isLoadingFeed: false})
            });
        }
    }

    _updateFeedData() {
        dataRegister.account(salesChannelRegister.get('market')).then((response) => {
            if (response.feed_pref) {
                this.setState({
                    feed_pref: response.feed_pref,
                    isLoadingFeed: false
                });
            } else {
                this.setState({
                    feed_pref: false,
                    isLoadingFeed: false
                });
            }
        }, (error) => {
            this.setState({
                feed_pref: false,
                isLoadingFeed: false
            });
        });
    }

    _updateCampaigns() {
        dataRegister.campaigns(salesChannelRegister.get('market'), langRegister.lang(), "draft?page="+this.state.page+"&per_page="+this.state.per_page).then((response) => {
            if(response.constructor === Array){
                this.setState({campaigns: response, isLoading: false, error: false, page: this.state.page + 1}, () => {
                    if(response.length < this.state.per_page){
                        this.setState({show_loadmore: false});
                    }
                });
            }else{
                this.setState({isLoading: false});
            }
        }, (error) => {
            if(error.status === 401){
                this._signOut();
            }else{
                this.setState({isLoading: false, error: true});
            }
        });
    }

    _updateList() {
        if (!this.state.list_switch) {
            this.setState({per_page: 10, page: 0, campaigns: [], show_loadmore: true}, () => {
                this._updateCampaigns()
            });
        } else {
            this.setState({per_page: 40, page: 0, campaigns: [], show_loadmore: true}, () => {
                this._updateCampaigns()
            });
        }
    }

    _loadMore(){
        this.setState({isLoadingButton: true}, () => {
            dataRegister.campaigns(salesChannelRegister.get('market'), langRegister.lang(), "draft?page="+this.state.page+"&per_page="+this.state.per_page).then((response) => {
                if(response.constructor === Array){
                    if(response.length > 0){
                        let campaigns = this.state.campaigns.concat(response);
                        this.setState({campaigns: campaigns, isLoadingButton: false, error: false, page: this.state.page + 1}, () => {
                            if(response.length < this.state.per_page){
                                this.setState({show_loadmore: false});
                            }
                        });
                    }else{
                        this.setState({isLoadingButton: false, error: false, show_loadmore: false});
                    }
                }else{
                    this.setState({isLoadingButton: false});
                }
            }, (error) => {
                if(error.status === 401){
                    this._signOut();
                }else{
                    this.setState({isLoadingButton: false, error: true});
                }
            });
        });
    }

    _signOut(){
        demoRegister.remove();
        userRegister.remove();
        tokenRegister.remove();
        agentRegister.remove();
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
    }

    _setLoader(value){
        this.setState({isLoading: value});
    }

    _updateAmount(){

    }

    _new(){
        try{
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
        }catch (error) {}
    }

    _filter(){
        let array = this.state.campaigns.filter((item) => {
            if((this.state.reseller || this.state.inhouse) && item.ref !== null){
                return item.industry.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 || item.company_name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 || item.ref.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 || JSON.stringify(item.id).indexOf(this.state.search.toLowerCase()) !== -1;
            } else if ((this.state.reseller || this.state.inhouse) && item.ref === null) {
                return item.industry.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 || item.company_name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 || JSON.stringify(item.id).indexOf(this.state.search.toLowerCase()) !== -1;
            } else{
                return item.industry.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 || JSON.stringify(item.id).indexOf(this.state.search.toLowerCase()) !== -1;
            }
        });
        return array;
    }

    _renderText(item) {
        return langRegister.get("user-campaigns-running", item);
    }

    render() {
        return (
            <div>
                <div className={Styles.contentHeader}>
                    <div className={Styles.contentHeaderSearch}>
                        <input value={this.state.search} onChange={(event) => this.setState({search: event.target.value})} placeholder={this._renderText("item_1")} className={Styles.contentHeaderSearchInput}/>
                        {
                            salesChannelRegister.get('name') === "propertybooster" &&
                            <img className={Styles.contentHeaderSearchInputIcon} src={require("../../assets/images/search_icon_2.png")}/>
                        }
                        {
                            salesChannelRegister.get('name') === "boostabostad" &&
                            <img className={Styles.contentHeaderSearchInputIcon} src={require("../../assets/images/search_icon_boostabostad.png")}/>
                        }
                        {
                            salesChannelRegister.get('name') === "yieldlock" &&
                            <img className={Styles.contentHeaderSearchInputIcon} src={require("../../assets/images/search_icon_2_yl.png")}/>
                        }
                    </div>
                    <LanguageButton props={this.props}/>
                    <div onClick={() => this._signOut()} className={Styles.contentHeaderButton}>
                        {this._renderText("item_2")}
                    </div>
                </div>
                <div className={Styles.container}>
                    {
                        !this.state.isLoading && !this.state.error &&
                        <div onClick={() => this._new()} className={Styles.button}>
                            <span className={Styles.buttonPlus}>+</span> <span className={Styles.buttonText}>{this._renderText("item_3")}</span>
                        </div>
                    }
                    {
                        !this.state.isLoading && !this.state.error && this.state.show_list_switch && this.state.campaigns.length > 0 &&
                        <div className={Styles.subTitleRightContainer}>
                        <div className={Styles.subTitleRight}>
                            {
                                salesChannelRegister.get("name") !== "yieldlock" &&
                                this.state.list_switch &&
                                <img onClick={() => {
                                    this.setState({list_switch: false, isLoading: true}, () => {
                                        this._updateList();
                                    });
                                }}
                                     className={Styles.subTitleRightSwitch}
                                     src={require("../../assets/images/push_black_on.svg")}/>
                            }
                            {
                                salesChannelRegister.get("name") === "yieldlock" &&
                                this.state.list_switch &&
                                <img onClick={() => {
                                    this.setState({list_switch: false, isLoading: true}, () => {
                                        this._updateList();
                                    });
                                }}
                                     className={Styles.subTitleRightSwitch}
                                     src={require("../../assets/images/slider_active_yl.svg")}/>
                            }
                            {
                                salesChannelRegister.get("name") !== "yieldlock" &&
                                !this.state.list_switch &&
                                <img onClick={() => {
                                    this.setState({list_switch: true, isLoading: true}, () => {
                                        this._updateList();
                                    });
                                }}
                                     className={Styles.subTitleRightSwitch}
                                     src={require("../../assets/images/push_black_off.svg")}/>
                            }
                            {
                                salesChannelRegister.get("name") === "yieldlock" &&
                                !this.state.list_switch &&
                                <img onClick={() => {
                                    this.setState({list_switch: true, isLoading: true}, () => {
                                        this._updateList();
                                    });
                                }}
                                     className={Styles.subTitleRightSwitch}
                                     src={require("../../assets/images/slider_deactive_yl.svg")}/>
                            }
                            {
                                salesChannelRegister.get('name') !== "yieldlock" &&
                                <img onClick={() => {
                                    if (this.state.list_switch) {
                                        this.setState({list_switch: false, isLoading: true}, () => {
                                            this._updateList();
                                        });
                                    } else {
                                        this.setState({list_switch: true, isLoading: true}, () => {
                                            this._updateList();
                                        });
                                    }
                                }}
                                    className={Styles.subTitleRightIcon}
                                    src={require("../../assets/images/list_icon.svg")}/>
                            }
                            {
                                salesChannelRegister.get('name') === "yieldlock" &&
                                <img onClick={() => {
                                    if (this.state.list_switch) {
                                        this.setState({list_switch: false, isLoading: true}, () => {
                                            this._updateList();
                                        });
                                    } else {
                                        this.setState({list_switch: true, isLoading: true}, () => {
                                            this._updateList();
                                        });
                                    }
                                }}
                                    className={Styles.subTitleRightIcon}
                                    src={require("../../assets/images/list_icon_yl2.svg")}/>
                            }
                        </div>
                        </div>
                    }
                    {
                        !this.state.isLoading && !this.state.error && this.state.show_list_switch && this.state.list_switch &&
                        <div className={Styles.subTitleRightCaptions}>
                            <div className={Styles.contentInnerItemHeader}>
                                <div className={Styles.contentInnerItemHeaderStatus}>
                                    {"Status"}
                                </div>
                                <div className={Styles.contentInnerItemHeaderImage}>
                                    {"Agent"}
                                </div>
                                <div className={Styles.contentInnerItemHeaderTitle}>
                                    {"Type"}
                                </div>
                                <div className={Styles.contentInnerItemContent}>
                                    <div className={Styles.contentInnerItemContentSpace}>

                                    </div>
                                    <div className={Styles.contentInnerItemContentDays}>
                                        {"Days left"}
                                    </div>
                                    <div className={Styles.contentInnerItemContentLeads}>
                                        {"Leads"}
                                    </div>
                                    <div className={Styles.contentInnerItemContentRef}>
                                        {"Ref"}
                                    </div>
                                </div>
                                <div style={{minWidth: "calc(var(--size-factor) * 50px)"}} className={Styles.contentInnerItemContentOptions}>

                                </div>
                            </div>
                        </div>
                    }
                    {
                        !this.state.list_switch && !this.state.isLoadingUser && !this.state.isLoadingFeed && !this.state.isLoading && this.state.campaigns.length > 0 && !this.state.error &&
                        this._filter().sort((a, b) => b.id - a.id).map((prop, key) => {
                            return (
                                <div key={prop.id}>
                                    <UserCampaignDraftsItem updateAmount={this._updateAmount} setLoader={this._setLoader} user={this.state.user} feed_pref={this.state.feed_pref} props={this.props} data={prop}/>
                                </div>
                            )
                        })
                    }
                    {
                        this.state.list_switch && !this.state.isLoadingUser && !this.state.isLoadingFeed && !this.state.isLoading && this.state.campaigns.length > 0 && !this.state.error &&
                        this._filter().sort((a, b) => b.id - a.id).map((prop, key) => {
                            return (
                                <div key={prop.id}>
                                    <UserCampaignDraftsItemList updateAmount={this._updateAmount} setLoader={this._setLoader} user={this.state.user} feed_pref={this.state.feed_pref} props={this.props} data={prop}/>
                                </div>
                            )
                        })
                    }
                    {
                        !this.state.isLoading && !this.state.error && this.state.show_loadmore &&
                        <div className={Styles.loadMoreButtonContainer}>
                            <div className={Styles.loadMoreButton} onClick={() => {this._loadMore()}}>
                                {
                                    this.state.isLoadingButton &&
                                    <BeatLoader size={10} color={'#ffffff'} loading={true}/>
                                }
                                {
                                    !this.state.isLoadingButton &&
                                    <img className={Styles.loadMoreButtonIcon} src={require("../../assets/images/plus_sign_white_small.png")}/>
                                }
                            </div>
                        </div>
                    }
                    {
                        !this.state.isLoading && this.state.campaigns.length < 1 && !this.state.error &&
                        <div className={Styles.noResult}>
                            {this._renderText("item_5")}
                        </div>
                    }
                    {
                        !this.state.isLoading && this.state.error &&
                        <div className={Styles.noResult}>
                            {this._renderText("item_6")}
                        </div>
                    }
                    {
                        this.state.isLoading &&
                        <div className={Styles.loader}>
                            <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default userCampaignsDrafts;


// WEBPACK FOOTER //
// ./src/components/user-campaigns-drafts/component.js